/**
 * Save handler for the Oncology File Upload modal.
 * Validates the uploaded file and triggers the Astera oncology CSV load endpoint.
 */

import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { DrugConfigOrg } from "../../../../enums/drugConfigOrg";
import { ToastMessages } from "../../../../enums/toastMessages";
import { logError } from "../../../../utils/customLogger";
import { uploadOncologyPaCsv } from "../apis/uploadOncologyPaCsv";

/**
 * Validates the file, uploads it to the Astera oncology CSV intake endpoint,
 * and closes the modal after the request completes.
 *
 * @param uploadedFile - The CSV file selected by the user (or null)
 * @param onSuccess - Callback invoked after the API call completes
 */
export const onSaveOncologyFile = async (
  uploadedFile: File | null,
  onSuccess: () => void,
): Promise<void> => {
  if (!uploadedFile) {
    toast.error(ToastMessages.ONCOLOGY_FILE_UPLOAD_NO_FILE);
    return;
  }

  try {
    const result = await uploadOncologyPaCsv(
      uploadedFile,
      DrugConfigOrg.ASTERA,
    );

    if (result.status === "success") {
      toast.success(ToastMessages.ONCOLOGY_FILE_UPLOAD_SUCCESS);
    } else if (result.status === "partial") {
      toast.error(ToastMessages.ONCOLOGY_FILE_UPLOAD_PARTIAL);
    } else {
      toast.error(ToastMessages.ONCOLOGY_FILE_UPLOAD_ERROR);
    }

    onSuccess();
  } catch (error) {
    logError(error as Error, "Error in oncology file upload");
    toast.error(ToastMessages.ONCOLOGY_FILE_UPLOAD_ERROR);
    onSuccess();
  }
};
